import React from 'react';
import { Link } from 'react-router-dom';
import { FiLock, FiLogIn, FiUserPlus } from 'react-icons/fi';
import './LoginPrompt.css';

const LoginPrompt = ({ message = "Inicia sesión para interactuar", onClose, variant = 'modal' }) => {
  if (variant === 'inline') {
    return (
      <div className="login-prompt-inline">
        <FiLock className="prompt-icon" />
        <p>{message}</p>
        <div className="prompt-actions">
          <Link to="/login" className="prompt-btn primary">
            <FiLogIn /> Iniciar Sesión
          </Link>
          <Link to="/register" className="prompt-btn secondary">
            <FiUserPlus /> Registrarse
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="login-prompt-overlay" onClick={onClose}>
      <div className="login-prompt-modal" onClick={(e) => e.stopPropagation()}>
        <div className="prompt-header">
          <div className="prompt-icon-wrapper">
            <FiLock />
          </div>
          <h3>¡Únete a Graphyra!</h3>
          <p>{message}</p>
        </div>
        
        <div className="prompt-benefits">
          <div className="benefit-item">
            <span>💬</span>
            <span>Comenta en publicaciones</span>
          </div>
          <div className="benefit-item">
            <span>❤️</span>
            <span>Reacciona al contenido</span>
          </div>
          <div className="benefit-item">
            <span>📝</span>
            <span>Publica tus propios artículos</span>
          </div>
          <div className="benefit-item">
            <span>🔖</span>
            <span>Guarda tus favoritos</span>
          </div>
        </div>

        <div className="prompt-actions">
          <Link to="/login" className="prompt-btn primary">
            <FiLogIn /> Iniciar Sesión
          </Link>
          <Link to="/register" className="prompt-btn secondary">
            <FiUserPlus /> Crear Cuenta
          </Link>
        </div>

        <button className="prompt-close" onClick={onClose}>
          Seguir explorando
        </button>
      </div>
    </div>
  );
};

export default LoginPrompt;
